import { GA } from '@gamiphy/analytics';

export const trackWelcomeScreenViewed = (): void => GA.trackEvent('onboarding', 'welcome_screen_viewed');

export const trackLaterClicked = (): void => GA.trackEvent('onboarding', 'later_clicked');

export const trackSignInClicked = (): void => GA.trackEvent('onboarding', 'sign_in_clicked');

export const trackClosed = (label: string): void => GA.trackEvent('onboarding', 'closed', label);

export const trackStarted = (): void => GA.trackEvent('onboarding', 'started');

export const trackCompleted = (): void => GA.trackEvent('onboarding', 'completed');

export const trackActionClicked = (label: string): void => GA.trackEvent('onboarding', 'action', label);

export const joinNowClicked = (): void => GA.trackEvent('onboarding', 'join_now');

export const indicatorClicked = (): void => GA.trackEvent('onboarding', 'indicator_clicked');
